import { render, staticRenderFns } from "./TabelaEquipe.vue?vue&type=template&id=5f599cb8&scoped=true"
import script from "./TabelaEquipe.vue?vue&type=script&lang=js"
export * from "./TabelaEquipe.vue?vue&type=script&lang=js"
import style0 from "./TabelaEquipe.vue?vue&type=style&index=0&id=5f599cb8&prod&lang=scss&scoped=true"
import style1 from "./TabelaEquipe.vue?vue&type=style&index=1&id=5f599cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f599cb8",
  null
  
)

export default component.exports